import React, { useState } from "react";
import { APP_DOMAIN, CHOOSE_COLOR } from "../../constants/constants";
import { useHistory } from 'react-router-dom';
import { useSafeNavigation } from '../../utils/safeNavigationUtils';

export  const NoResumeFound = () =>{
    const history = useHistory();
    const { push: safePush } = useSafeNavigation(history);
    
    const handleCreateResume = () => {
        safePush(CHOOSE_COLOR);
      };
    return(
        <>
            <div className="no-resume-main-container">
                <div className='create-btn'>
                    <div className="create-new-resume" onClick={handleCreateResume}>
                    <span>+ Start a New Resume</span>
                    </div>
                </div>
                <div className="list-container">
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/AI.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>AI resume builder</h3>
                            <p>Never get stuck on what to say — use AI resume writing suggestions to build a resume that matches any job description</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/ATS.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>Start with resume templates</h3>
                            <p>Choose from over 30 templates that are stylish and ATS-friendly</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/font-color.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>Personalize the look of your resume</h3>
                            <p>Choose personalized fonts and colors for any resume template.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/search.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>Get inspired by resume examples</h3>
                            <p>View resume examples and templates to compare your resume to what’s common for your industry.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/newATS.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>ATS-friendly templates</h3>
                            <p>Use resume templates that are readable for ATS and recruiters alike.</p>
                        </div>
                    </div>
                    <div className="list-item">
                        <div className="icon">
                            <img
                                src={`${APP_DOMAIN}/assets/images-new/icons/personal.svg`}
                                alt="AI resume builder"
                            />
                        </div>
                        <div className="info">
                            <h3>Expert support</h3>
                            <p>Use expert tips as you build your resume with suggested phrases and guidance.</p>
                        </div>
                    </div>
                </div>
                <div className='create-btn'>
                    <div className="create-new-resume" onClick={handleCreateResume}>
                    <span>+ Start a New Resume</span>
                    </div>
                </div>
            </div>
        </>
    );
}   